import type { ColGroupDef } from 'ag-grid-community'

import AnalyticsKpisBuilder from '../AnalyticsKpisBuilder'
import { formatMoney } from '../utils'

export const mwmIapArpuDefs: ColGroupDef = {
  children: [
    {
      aggFunc: 'mwmIapArpud0Avg',
      field: 'mwm_inapps_revenue_per_install_d0_eur',
      headerName: 'D0',
      type: 'numericColumn',
      valueFormatter: formatMoney,
      valueGetter: AnalyticsKpisBuilder.buildKpi,
    },
    {
      aggFunc: 'mwmIapArpud1Avg',
      field: 'mwm_inapps_revenue_per_install_d1_eur',
      headerName: 'D1',
      type: 'numericColumn',
      valueFormatter: formatMoney,
      valueGetter: AnalyticsKpisBuilder.buildKpi,
    },
    {
      aggFunc: 'mwmIapArpud3Avg',
      field: 'mwm_inapps_revenue_per_install_d3_eur',
      headerName: 'D3',
      type: 'numericColumn',
      valueFormatter: formatMoney,
      valueGetter: AnalyticsKpisBuilder.buildKpi,
    },
    {
      aggFunc: 'mwmIapArpud7Avg',
      field: 'mwm_inapps_revenue_per_install_d7_eur',
      headerName: 'D7',
      type: 'numericColumn',
      valueFormatter: formatMoney,
      valueGetter: AnalyticsKpisBuilder.buildKpi,
    },
    {
      aggFunc: 'mwmIapArpud10Avg',
      field: 'mwm_inapps_revenue_per_install_d10_eur',
      headerName: 'D10',
      type: 'numericColumn',
      valueFormatter: formatMoney,
      valueGetter: AnalyticsKpisBuilder.buildKpi,
    },
    {
      aggFunc: 'mwmIapArpud30Avg',
      field: 'mwm_inapps_revenue_per_install_d30_eur',
      headerName: 'D30',
      type: 'numericColumn',
      valueFormatter: formatMoney,
      valueGetter: AnalyticsKpisBuilder.buildKpi,
    },
    {
      aggFunc: 'mwmIapArpud180Avg',
      field: 'mwm_inapps_revenue_per_install_d180_eur',
      headerName: 'D180',
      type: 'numericColumn',
      valueFormatter: formatMoney,
      valueGetter: AnalyticsKpisBuilder.buildKpi,
    },
    {
      aggFunc: 'mwmIapArpud360Avg',
      field: 'mwm_inapps_revenue_per_install_d360_eur',
      headerName: 'D360',
      type: 'numericColumn',
      valueFormatter: formatMoney,
      valueGetter: AnalyticsKpisBuilder.buildKpi,
    },
    {
      aggFunc: 'mwmIapArpudTotalAvg',
      field: 'mwm_inapps_revenue_per_install_total_eur',
      headerName: 'Total',
      type: 'numericColumn',
      valueFormatter: formatMoney,
      valueGetter: AnalyticsKpisBuilder.buildKpi,
    },
  ],
  headerClass: 'greyFill',
  headerName: 'MWM IAP ARPU',
}
